<template>

    <div id="content" role="main">

      <div class="row mt-5">
        <div class="col-md-12">
          <div class="content_title">
            <h1>{{ $t("message.api_h1") }}</h1>
          </div>
        </div>
      </div>
      <div class="container mt-3">

        <div class="alert alert-info">
            {{ $t("message.api_url") }}
            <router-link to="/apiDoc" target="_blank">
              https://www.biotech-analytics/#/apiDoc
            </router-link>
        </div>

      </div>

      <ApiDokumentation :show-tokens="true" />

    </div>

</template>

<script>

  import axios from 'axios'
  import ApiDokumentation from '@/components/doc/ApiDokumentation.vue'
  axios.defaults.withCredentials = true

  export default {

    name: 'Export',
    components: {
      ApiDokumentation,
    },

  }

</script>
